<template>
  <list-row
    ref="listRowRef"
    class="pw-order-row"
    :to="{ name: 'OrderDetails', params: { id: order.id } }"
  >
    <template #title>
      <div class="d-flex ga-1 align-center">
        <sf-text ref="title" class="text-truncate">
          {{ order.orderNumber }}
        </sf-text>
        <topi-badge v-if="order.isTopiOrder" small />
      </div>

      <sf-secondary-text ref="info">
        <template v-if="order.distributorNames.length > 0">
          <span>{{ formatDistributors(order.distributorNames) }}</span>
          <span class="mx-1">-</span>
        </template>
        <span>{{ order.initiatorFullName }}</span>
        <span class="mx-1">-</span>
        <span>{{ $t('positions', order.itemCount) }}</span>
        <template v-if="order.isArchived">
          <span class="mx-1">-</span>
          <span ref="archived">{{ $t('common.archived') }}</span>
        </template>
      </sf-secondary-text>
    </template>
    <template #date>
      <sf-text v-if="order.sentDate" ref="date">
        {{ formatDate(order.sentDate) }}
      </sf-text>
    </template>
    <template v-if="!hideSum" #costs>
      <sf-heading ref="costs">
        {{ formatMoney(order.sum, false, true) }}
      </sf-heading>
    </template>
    <template #status>
      <sf-color-text ref="status" :color="getOrderStatusColor(order.orderStatus)">
        {{ $t('orderStatus.' + order.orderStatus) }}
      </sf-color-text>
    </template>
  </list-row>
</template>

<script setup lang="ts">
import ListRow from '@/components/list/ListRow.vue'
import SfColorText from '@/components/text/SfColorText.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfSecondaryText from '@/components/text/SfSecondaryText.vue'
import SfText from '@/components/text/SfText.vue'
import { Order, OrderStatus } from '@/generatedTypes'
import { formatDistributors, getOrderStatusColor } from '@/modules/order/helpers'
import { formatMoney } from '@/modules/product/helpers'
import TopiBadge from '@/modules/topi/components/TopiBadge.vue'
import { formatDate } from '@/utils/timeFormatHelpers'
import { VueInstance } from '@vueuse/core'
import { computed, PropType, ref, watch } from 'vue'

const props = defineProps({
  order: {
    type: Object as PropType<Order>,
    required: true
  },
  isFocused: {
    type: Boolean,
    default: false
  }
})

const hideSum = computed(() => {
  return (
    props.order.isTopiOrder &&
    (props.order.orderStatus === OrderStatus.IN_TOPI_CHECKOUT ||
      props.order.orderStatus === OrderStatus.TOPI_EXPIRED)
  )
})

const listRowRef = ref<VueInstance | null>(null)

watch(
  () => props.isFocused,
  () => {
    if (props.isFocused) {
      listRowRef.value?.$el.focus()
    } else {
      listRowRef.value?.$el.blur()
    }
  }
)
</script>
